import { GetTransportQuery, PagedListingResponseOfTransportModel, TransportModel } from "@core/services/api.service";

export class LoadTransportListAction {
    static readonly type = '[TransportList] Load Transport list';
    constructor(public payload: { GetTransportQuery: GetTransportQuery }) { }
}
export class LoadTransportListSuccessAction {
    static readonly type = '[TransportList] Load Transport list Success';

    constructor(public payload: { transportList: PagedListingResponseOfTransportModel }) { }
}

export class LoadTransportListFailAction {
    static readonly type = '[TransportList] Load Transport list Fail';
}
export class GetTransportByIdAction {
    static readonly type = '[Transport] Get Transport By ID';

    constructor(public transportId: number) { }
}

export class GetTransportByIdSuccessAction {
    static readonly type = '[Transport] Get Transport By ID Success';

    constructor(public payload: TransportModel) { }
}

export class GetTransportByIdFailAction {
    static readonly type = '[Transport] Get Transport By ID Fail';
}